import { ref, watch } from 'vue'
import { useLoadObjectCoords, useSendObjectCoords } from './api.ts'
import { useTranslate } from '@/shared/lib'
import { useNotification } from '@/shared/ui'
import { cloneDeep } from 'lodash'

export const useModel = () => {
  const { trs } = useTranslate()
  const { addError } = useNotification()
  const { save } = useSendObjectCoords()

  const openForm = ref(false)
  const coords = ref<any[]>([])
  const isPolygon = ref(false)
  const currentObjectId = ref<number>(0)

  /**
   * Функция загрузки координат
   * @param objectId
   */
  const loadCoords = (objectId: number) => {
    currentObjectId.value = objectId
    const result = useLoadObjectCoords(objectId, openForm)

    watch(
      result.data,
      () => {
        if (result.data.value) {
          coords.value = cloneDeep(result.data.value.coordinates || [])
          isPolygon.value = compareCoords()
        }
      },
      { immediate: true },
    )

    return result
  }

  /**
   * Функция удаления координат
   * @param index
   */
  const removeCoords = (index: number) => {
    coords.value = coords.value.filter((_, itemIndex) => itemIndex != index)
  }

  /**
   * Установка координат точки по положению пользователя
   * @param index
   */
  const setUserCoords = (index: number) => {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const newCoords = [...coords.value]
        newCoords[index] = [position.coords.longitude, position.coords.latitude]
        coords.value = newCoords
      },
      () => {
        addError(trs('request.not_geoposition'))
      },
    )
  }

  /**
   * Добавить строку в координаты
   * @param index
   * @param direction
   */
  const addCoordsRow = (index: number, direction: 'up' | 'down') => {
    const targetIndex = direction == 'up' ? index : index + 1

    coords.value = [
      ...coords.value.slice(0, targetIndex),
      [0, 0],
      ...coords.value.slice(targetIndex),
    ]
  }

  /**
   * Функция отправки координат
   */
  const sendCoords = async (objectId: number) => {
    coords.value = coords.value.map((item) => [Number(item[0]), Number(item[1])])

    if (isPolygon.value && !compareCoords()) {
      coords.value[coords.value.length] = coords.value[0]
    }

    await save(objectId, coords.value)
  }

  /**
   * Функция сравнения координат
   */
  const compareCoords = () => {
    return (
      coords.value.length > 2 &&
      coords.value[0][0] === coords.value[coords.value.length - 1][0] &&
      coords.value[0][1] === coords.value[coords.value.length - 1][1]
    )
  }

  return {
    openForm,
    coords,
    isPolygon,
    currentObjectId,

    loadCoords,
    removeCoords,
    setUserCoords,
    addCoordsRow,
    sendCoords,
    compareCoords,
  }
}
